import { render, staticRenderFns } from "./ResultAnswers.vue?vue&type=template&id=1bf8eef2&"
import script from "./ResultAnswers.vue?vue&type=script&lang=js&"
export * from "./ResultAnswers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports